import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { useNavigation } from '@refinedev/core';
import { Form, Input, InputNumber, Switch, message } from 'antd';

export const LanguageCreate: React.FC = () => {
  const { formProps, onFinish } = useForm({ resource: 'languages' });
  const { push } = useNavigation();

  const handleSubmit = async (values: any) => {
    try {
      await onFinish(values);
      message.success('Language created');
      push('/languages');
    } catch (err: any) {
      message.error(err?.message || 'Failed to create language');
    }
  };

  return (
    <Create resource="languages" saveButtonProps={{ onClick: () => formProps.form?.submit() }}>
      <Form {...formProps} layout="vertical" onFinish={handleSubmit}>
        <Form.Item label="Code" name="code" rules={[{ required: true, message: 'Locale code is required (e.g. ja-JP)' }]}>
          <Input placeholder="e.g. ja-JP" />
        </Form.Item>
        <Form.Item label="Label" name="label" rules={[{ required: true, message: 'Display label is required' }]}>
          <Input placeholder="e.g. 日本語" />
        </Form.Item>
        <Form.Item label="Active" name="isActive" valuePropName="checked" initialValue={true}>
          <Switch />
        </Form.Item>
        <Form.Item label="Sort Order" name="sortOrder" initialValue={0}>
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
      </Form>
    </Create>
  );
};
